import { Anchor, Container, MediaGallery, RichText, Text } from '@ahc-digital/component-library';
import { Placeholder, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { MEDIA_GALLERY_CONTAINER } from 'src/shared/static';
import { SwitchToPreviewMessage } from 'src/shared/SwitchToPreviewMessage';
import { translationClasses } from 'src/shared/TranslationClasses';
import { GetMediaGalleryModel } from './C43MediaGallery.service';
import { C43MediaGalleryProps } from './C43MediaGallery.types';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { getCheckbox } from 'src/shared/param-utils';

export const Default = (props?: C43MediaGalleryProps): JSX.Element => {
  const phKey = MEDIA_GALLERY_CONTAINER + `-${props?.params?.DynamicPlaceholderId}`;
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;
  const model = GetMediaGalleryModel(props);
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return (
    <>
      {isEditing ? (
        <SwitchToPreviewMessage componentName={props?.rendering?.componentName}>
          <Container>
            <div style={{ display: 'grid', gap: '0.5rem', marginBottom: '1rem' }}>
              <span>
                <b>Headline:</b>
              </span>
              <Text tag={model.headlineTag}>{model.headline}</Text>
            </div>
            <div style={{ display: 'grid', gap: '0.5rem', marginBottom: '1rem' }}>
              <span>
                <b>Support copy:</b>
              </span>
              <RichText>{model.supportCopy}</RichText>
            </div>
            {props?.rendering && <Placeholder name={phKey} rendering={props?.rendering} />}
            <Anchor buttonStyle="outlined" size="responsive">
              {model.cta}
            </Anchor>
          </Container>
        </SwitchToPreviewMessage>
      ) : (
        <MediaGallery
          id={props?.params?.AnchorLinkTargetName}
          className={translationClasses(props?.params)}
          data-component={marketingRenderingName}
          shouldLazyLoad={getCheckbox(props?.params?.ShouldLazyLoad)}
          {...model}
        />
      )}
    </>
  );
};
